function amountFromOffer(offerString: string): number {
  const amount = parseInt(offerString.substring("/offer/".length));
  return isNaN(amount) || amount < 1 ? 0 : amount;
}

export { amountFromOffer };
